import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApiService } from "../../../api/api.service";
import { UnauthorizedStore } from "./unauthorized.store";

@Injectable()
export class UnauthorizedService {
    constructor(
        private store: UnauthorizedStore,
        private api: ApiService
    ) {}

    public loadSessionInfo(): Observable<void> {
        return this.api.session.getInfo().pipe(map(session => this.store.update({ session })));
    }
}
